/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityDomainsEmailAggData
 */
export interface MonitEntityDomainsEmailAggData {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityDomainsEmailAggData
     */
    total?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityDomainsEmailAggData
     */
    domains?: Array<string>;
}

/**
 * Check if a given object implements the MonitEntityDomainsEmailAggData interface.
 */
export function instanceOfMonitEntityDomainsEmailAggData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityDomainsEmailAggDataFromJSON(json: any): MonitEntityDomainsEmailAggData {
    return MonitEntityDomainsEmailAggDataFromJSONTyped(json, false);
}

export function MonitEntityDomainsEmailAggDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityDomainsEmailAggData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
    };
}

export function MonitEntityDomainsEmailAggDataToJSON(value?: MonitEntityDomainsEmailAggData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'domains': value.domains,
    };
}

